import { useState } from "react";
import * as Icons from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import GatePassRegister from "@/pages/GatePassRegister";
import GatePassEditor from "@/pages/GatePassEditor";

export default function GatePass() {
  const { can } = useAuth();
  const [tab, setTab] = useState("register");

  if (!can("gate_pass", "view"))
    return (
      <div className="max-w-md mx-auto mt-16 text-center" data-testid="restricted-notice">
        <div className="h-14 w-14 rounded-2xl bg-destructive/10 text-destructive flex items-center justify-center mx-auto mb-4"><Icons.Lock className="h-6 w-6" /></div>
        <h2 className="font-display text-xl font-bold">Access Restricted</h2>
        <p className="text-muted-foreground text-sm mt-2">You don't have permission to view Gate Passes.</p>
      </div>
    );

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="h-11 w-11 rounded-xl flex items-center justify-center" style={{ backgroundColor: "#1e3a5f1a", color: "#1e3a5f" }}>
          <Icons.ClipboardCheck className="h-5 w-5" />
        </div>
        <div>
          <h1 className="font-display text-2xl font-bold tracking-tight">Gate Pass</h1>
          <p className="text-sm text-muted-foreground">Generate, authorize and track material &amp; vehicle movements.</p>
        </div>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList data-testid="gp-tabs">
          <TabsTrigger value="register" data-testid="gp-tab-register">Register</TabsTrigger>
          {can("gate_pass", "create") && <TabsTrigger value="create" data-testid="gp-tab-create">Create Gate Pass</TabsTrigger>}
        </TabsList>
        <TabsContent value="register" className="mt-5">
          <GatePassRegister embedded onNew={() => setTab("create")} />
        </TabsContent>
        {can("gate_pass", "create") && (
          <TabsContent value="create" className="mt-5">
            <GatePassEditor embedded onDone={() => setTab("register")} />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}
